import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Component({
  selector: 'app-meeting-record-acta-tab',
  templateUrl: './meeting-record-acta-tab.component.html',
  styleUrls: ['../meeting-record-editor-tab.styles.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, EditorComponent],
})
export class MeetingRecordActaTabComponent {
  form_group = input.required<FormGroup>();

  tiny_mce_api_key = input.required<string>();

  tiny_mce_init = input.required<Record<string, unknown>>();

  onEditorInit(_event: { editor: unknown }): void {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }
}
